var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('summernote',{ref:"summernote",attrs:{"id":_vm.editorId,"option":_vm.option,"disable":_vm.disabled,"data":_vm.data,"mallNo":_vm.mallNo,"editorId":_vm.editorId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }